"use client";
import { ChevronLeft, ChevronRight } from "lucide-react";

type CarouselControlsProps = {
	total: number;
	activeIndex: number;
	onPrev: () => void;
	onNext: () => void;
	disablePrev: boolean;
	disableNext: boolean;
	onDotClick: (index: number) => void;
};

export default function CarouselControls({
	total,
	activeIndex,
	onPrev,
	onNext,
	disablePrev,
	disableNext,
	onDotClick,
}: CarouselControlsProps) {
	return (
		<div className="flex items-center justify-center gap-6 mt-4">
			{/* Freccia sinistra */}
			<button
				onClick={onPrev}
				disabled={disablePrev}
				className="hidden sm:inline-flex cursor-pointer text-(--card) p-2 rounded-full shadow transition disabled:opacity-50 bg-(--card)"
			>
				<ChevronLeft className="w-5 h-5 text-(--card-foreground)" />
			</button>

			{/* Dots */}
			<div className="flex gap-2">
				{Array.from({ length: total }).map((_, i) => (
					<div
						key={i}
						onClick={() => onDotClick(i)}
						className={`cursor-pointer w-2.5 h-2.5 rounded-full transition ${
							i === activeIndex
								? "bg-(--card-foreground)"
								: "bg-(--bg-secondary) border border-(--card-foreground)"
						}`}
					/>
				))}
			</div>

			{/* Freccia destra */}
			<button
				onClick={onNext}
				disabled={disableNext}
				className="hidden sm:inline-flex cursor-pointer p-2 rounded-full shadow transition disabled:opacity-50 bg-(--card)"
			>
				<ChevronRight className="w-5 h-5 text-(--card-foreground)" />
			</button>
		</div>
	);
}
